"use client";

import { useUnit } from "@/context/unit-context";
import { useEffect, useLayoutEffect } from "react";

const useIsomorphicLayoutEffect =
  typeof window !== "undefined" ? useLayoutEffect : useEffect;

export default function ArticleUnitSetter({
  unit,
}: {
  unit: string | undefined;
}) {
  const { setCurrentUnit } = useUnit();
  useIsomorphicLayoutEffect(() => {
    setCurrentUnit(unit ?? null);
    return () => setCurrentUnit(null);
  }, [unit, setCurrentUnit]);

  return null;
}
